import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context38; _forEachInstanceProperty(_context38 = ownKeys(source, true)).call(_context38, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context39; _forEachInstanceProperty(_context39 = ownKeys(source)).call(_context39, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { defaultListState, defaultItemState, defaultPaginationState } from './defaults';
import { setPagination } from './pagination';
import { ENTITIES, LISTS, ITEMS, DATA, CONSUMERS, ARGS, RELATED, ERROR, STATUS, STATUS_ERROR, SOURCE, SOURCE_ITEM, SOURCE_LIST, PAGINATION, PAGINATION_ITEMS_PER_PAGE, PAGINATION_CURRENT, ETAG } from './constants';
import { createEtag } from './etags';
import { __DEV__ } from './env';
import { isFunction, get, set, mergeWith, isArray, memoize, camelCase, isObject, merge } from 'lodash';
/**
 * Returns pagination object of list response
 * NOTE: our backend changed the structure of the list response between
 * the last projects, so we have to do the || here
 * @param  {Object} list
 * @return {Object}
 */

function getPagination(list) {
  return get(list, 'meta.pagination') || get(list, 'pagination');
}
/**
 * Process API results
 * @param  {Object} result
 * @param  {Object} relatedConfig
 * @return {Object}
 */


export function processEntityItem(result) {
  var relatedConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // This is probably one of the biggest and most important steps, where the main
  //  normalization (similar to `normalizr`) happens! We extract the core item information,
  //  as well as all relations (normalized for this item as well as nornmalized for the
  //  global state structure).
  // This will be called after the API call, and will then be resolved into the local
  //  enitity state, as well as trigger `pushItems` for all related fields loaded with
  //  it.
  // This will also be called on `pushItem`/`pushItems`, so we don't need to worry about
  //  recursive normalization here, as it will happen later, and can just pass on the
  //  related data as is :)
  var item = _objectSpread({}, result.data);

  var related = {};
  var relatedData = {};

  for (var name in relatedConfig) {
    var field = relatedConfig[name];

    if (!field || !field.model) {
      continue;
    }

    var relatedModel = field.model; // If the model is defined as a function, call the function with
    // the item data ... this is used e.g. to define relations that
    // depend on the item data

    if (relatedModel && isFunction(relatedModel) && !relatedModel.modelName) {
      relatedModel = relatedModel(item);
    }

    var _isArray = false;

    if (_Array$isArray(relatedModel)) {
      relatedModel = relatedModel[0];
      _isArray = true;
    }

    if (!relatedModel) {
      continue;
    } // You can define the final key, if you want it to be different
    //  from the field key in the response


    var key = field.name || name;
    var relatedItems = get(item, name);

    if (relatedItems) {
      if (_isArray) {
        var _ret = function () {
          var _context, _context2;

          if (!relatedItems.data && _Array$isArray(relatedItems)) {
            relatedItems = {
              data: relatedItems
            };
          }

          if (!relatedItems.data) {
            return "continue";
          } // Related list


          var items = {};
          var ids = [];

          _forEachInstanceProperty(_context = relatedItems.data).call(_context, function (item) {
            items[item.id] = _defineProperty({}, DATA, item);
            ids.push(item.id);
          });

          relatedData[relatedModel.modelName] = _defineProperty({}, ITEMS, _objectSpread({}, get(relatedData, _concatInstanceProperty(_context2 = "".concat(relatedModel.modelName, ".")).call(_context2, ITEMS), {}), {}, items)); // Normalized related list

          related[key] = _defineProperty({
            type: [relatedModel.modelName]
          }, ITEMS, ids);
        }();

        if (_ret === "continue") continue;
      } else {
        // 1:1 relationship
        // NOTE: with new APIs we apparently serve flat single records,
        //  old APIs had the entity attributes stored in a `data` object.
        // TODO: This will get super confusing, so we should find a better
        //  abstraction for this
        var relatedItem = relatedItems.data ? relatedItems.data : relatedItems;
        relatedData[relatedModel.modelName] = _defineProperty({}, ITEMS, _objectSpread({}, relatedData[relatedModel.modelName] ? relatedData[relatedModel.modelName][ITEMS] : {}, _defineProperty({}, relatedItem.id, _defineProperty({}, DATA, relatedItem)))); // Normalized related list

        related[key] = _defineProperty({
          type: relatedModel.modelName
        }, ITEMS, [relatedItem.id]);
      }
    } // Remove related from core item data


    delete item[name];
  }

  return {
    item: item,
    related: related,
    relatedData: relatedData
  };
}
/**
 * Set record and list data considering given meta information
 * @param {Object} state
 * @param {string} id
 * @param {Object} list
 */

export function setEntityList(state, id, list) {
  var _context3, _context4, _context5, _objectSpread3;

  _forEachInstanceProperty(_context3 = list.data).call(_context3, function (listItem) {
    var item = listItem.item,
        related = listItem.related;
    state = setEntityItem(state, item.id, item, SOURCE_LIST, related, {
      include: get(list, 'args.include')
    });
  });

  var pagination = getPagination(list);
  return _objectSpread({}, state, _defineProperty({}, LISTS, _objectSpread({}, state[LISTS], _defineProperty({}, id, _objectSpread({}, get(state, _concatInstanceProperty(_context4 = "".concat(LISTS, ".")).call(_context4, id), defaultListState), (_objectSpread3 = {}, _defineProperty(_objectSpread3, ARGS, list.args), _defineProperty(_objectSpread3, ITEMS, _mapInstanceProperty(_context5 = list.data).call(_context5, function (_ref) {
    var item = _ref.item;
    return item.id;
  })), _defineProperty(_objectSpread3, ETAG, createEtag()), _defineProperty(_objectSpread3, PAGINATION, setPagination(pagination)), _objectSpread3))))));
}
/**
 * Seperate normalization for loading additional pages for a list,
 * because setEntityList should reset all existing items while
 * this method merges items also considering adding NULLed gaps
 * when skipping pages, like so: [ID, ID, null, null, ID, ID]
 * @param {Object} state
 * @param {string} id
 * @param {Object} list
 */

export function setEntityListPage(state, id, list) {
  var _context6, _context7, _context8, _context9, _context10, _objectSpread6;

  var currentPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var pagination = getPagination(list);

  if (!pagination) {
    // No pagination data found, so we can treat it like a first page fetch
    //  and run the default action `setEntityList`
    return setEntityList(state, id, list);
  } // Normalize pagination first!


  pagination = setPagination(pagination);
  var newPage = currentPage || pagination[PAGINATION_CURRENT];

  if (!newPage) {
    newPage = 1;
  }

  var startIndex = (newPage - 1) * pagination[PAGINATION_ITEMS_PER_PAGE];
  var newItems = get(_objectSpread({}, state), _concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = "".concat(LISTS, ".")).call(_context7, id, ".")).call(_context6, ITEMS), []);

  while (newItems.length < startIndex) {
    // Fill up gaps with NULL values as placeholder for potentially
    //  skipped pages
    newItems.push(null);
  }

  for (var i = startIndex; i < startIndex + pagination[PAGINATION_ITEMS_PER_PAGE]; i++) {
    // Set new items, potentially overriding old data when refreshing an existing
    //  page for example
    var listIndex = i - startIndex;
    var itemId = get(list, "data.".concat(listIndex, ".item.id")); // NOTE: we do not null the end of the page anymore (e.g. if a page of size 10
    //  has only 5 items) because it lead to weird issues on application level

    if (itemId) {
      newItems[i] = itemId;
    } else {
      // If we hit this point, we can assume that this is the end of the list, so
      // we can delete all following items from it...
      _spliceInstanceProperty(newItems).call(newItems, i, newItems.length - i);

      break;
    }
  }

  _forEachInstanceProperty(_context8 = list.data).call(_context8, function (listItem) {
    // Push all individual entity items to their respective place in the store
    var item = listItem.item,
        related = listItem.related;
    state = setEntityItem(state, item.id, item, SOURCE_LIST, related);
  });

  var listState = get(state, _concatInstanceProperty(_context9 = "".concat(LISTS, ".")).call(_context9, id), defaultListState);
  var newState = set(_objectSpread({}, state), _concatInstanceProperty(_context10 = "".concat(LISTS, ".")).call(_context10, id), _objectSpread({}, listState, (_objectSpread6 = {}, _defineProperty(_objectSpread6, ARGS, list[ARGS]), _defineProperty(_objectSpread6, ITEMS, newItems), _defineProperty(_objectSpread6, ETAG, createEtag()), _defineProperty(_objectSpread6, PAGINATION, pagination), _objectSpread6)));
  return newState;
}
export function setEntityItem(state, id, item) {
  var _context11, _context12, _objectSpread7;

  var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : SOURCE_ITEM;
  var related = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var args = arguments.length > 5 ? arguments[5] : undefined;
  var currState = get(state, _concatInstanceProperty(_context11 = "".concat(ITEMS, ".")).call(_context11, id), defaultItemState); // NOTE: remove, we are not using this

  var sources = _filterInstanceProperty(_context12 = get(currState, SOURCE, '').split('|')).call(_context12, function (a) {
    return a;
  });

  sources.push(source);
  sources = sources.join('|'); // We always want to merge item data with currently stored data,
  // so be able to serve all consumers correctly

  var currData = get(currState, DATA);

  if (currData) {
    // NOTE: we want to deep merge all data, e.g. to merge all nested
    // relations etc ... exception of this is lists, so we implement
    // a custom merge method that checks for arrays and avoids deep
    // merging those!
    item = mergeWith({}, currData, item, function (oldVal, newVal) {
      if (isArray(newVal)) {
        return newVal;
      }
    });
  } // ...the same goes for related entities ... be don't need to deep
  // merge here tho


  var currRelated = get(currState, RELATED);

  if (currRelated) {
    related = _objectSpread({}, currRelated, {}, related);
  }

  return _objectSpread({}, state, _defineProperty({}, ITEMS, _objectSpread({}, state[ITEMS], _defineProperty({}, id, _objectSpread({}, currState, (_objectSpread7 = {}, _defineProperty(_objectSpread7, DATA, item), _defineProperty(_objectSpread7, ARGS, args), _defineProperty(_objectSpread7, RELATED, related), _defineProperty(_objectSpread7, SOURCE, sources), _defineProperty(_objectSpread7, ETAG, createEtag()), _objectSpread7))))));
}
/**
 * Get item / list data
 * @param  {Object} state
 * @param  {string} type
 * @param  {string} id
 * @return {Object}
 */

export function getEntityList(state, type, id, fields) {
  var _context13, _context14, _context15, _context16, _ref2;

  type = camelCase(type);
  var list = get(state, _concatInstanceProperty(_context13 = _concatInstanceProperty(_context14 = _concatInstanceProperty(_context15 = "".concat(ENTITIES, ".")).call(_context15, type, ".")).call(_context14, LISTS, ".")).call(_context13, id));

  if (!list) {
    return null;
  }

  return _ref2 = {}, _defineProperty(_ref2, ARGS, list[ARGS]), _defineProperty(_ref2, ITEMS, _mapInstanceProperty(_context16 = list[ITEMS]).call(_context16, function (item) {
    var listItem = getEntityItem(state, type, item, fields);
    return listItem ? listItem[DATA] : null;
  })), _defineProperty(_ref2, STATUS, list[STATUS]), _defineProperty(_ref2, CONSUMERS, list[CONSUMERS]), _defineProperty(_ref2, ETAG, list[ETAG]), _defineProperty(_ref2, PAGINATION, list[PAGINATION]), _defineProperty(_ref2, ERROR, list[STATUS] === STATUS_ERROR ? list[ERROR] : null), _ref2;
}
/**
 * Memoized version of `getEntityList`, using etags of all list items
 * and their relations (optionally filtered by fields object)
 */

export var memGetEntityList = memoize(getEntityList, function (state, type, id, fields) {
  return getEntityListEtagTree(state, type, id, fields).join('--');
});
/**
 * Get etag list for all list items recursively including their related items,
 * optionally filtered by fields object
 * @param  {Object} state
 * @param  {String} type
 * @param  {String|int} id
 * @param  {Object} fields
 * @return {Array}
 */

export function getEntityListEtagTree(state, type, id, fields) {
  var _context17, _context18, _context19, _context20;

  type = camelCase(type);
  var list = get(state, _concatInstanceProperty(_context17 = _concatInstanceProperty(_context18 = _concatInstanceProperty(_context19 = "".concat(ENTITIES, ".")).call(_context19, type, ".")).call(_context18, LISTS, ".")).call(_context17, id), {});
  var etags = [list[ETAG]];

  if (!list[ITEMS]) {
    return etags;
  }

  _forEachInstanceProperty(_context20 = list[ITEMS]).call(_context20, function (itemId) {
    etags = _concatInstanceProperty(etags).call(etags, getEntityItemEtagTree(state, type, itemId, fields));
  });

  return etags;
}
/**
 * Get entity item information, optionally filtered to specific fields
 * @param  {Object} state
 * @param  {String} type
 * @param  {String|int} id
 * @param  {Object} fields
 * @return {Object}
 */

export function getEntityItem(state, type, id, fields) {
  var _context21, _context22, _context23, _ref3;

  type = camelCase(type);
  var item = get(state, _concatInstanceProperty(_context21 = _concatInstanceProperty(_context22 = _concatInstanceProperty(_context23 = "".concat(ENTITIES, ".")).call(_context23, type, ".")).call(_context22, ITEMS, ".")).call(_context21, id));

  if (!item) {
    return null;
  }

  return _ref3 = {}, _defineProperty(_ref3, DATA, getEntityItemData(state, type, id, fields)), _defineProperty(_ref3, ARGS, item[ARGS]), _defineProperty(_ref3, STATUS, item[STATUS]), _defineProperty(_ref3, CONSUMERS, item[CONSUMERS]), _defineProperty(_ref3, ERROR, item[STATUS] === STATUS_ERROR ? item[ERROR] : null), _defineProperty(_ref3, RELATED, item[RELATED]), _defineProperty(_ref3, ETAG, item[ETAG]), _ref3;
}
/**
 * Memoized version of `getEntityItem`, using the etag-tree build from
 * requested field as memoization key
 */

export var memGetEntityItem = memoize(getEntityItem, function (state, type, id) {
  return getEntityItemEtagTree(state, type, id).join('--');
});
/**
 * Recursively get item data including (nested) relations
 * Accepts a fields objects to filter to specific relations!
 * @param  {Object} state
 * @param  {String} type
 * @param  {String|int} id
 * @param  {Object} fields - optional
 * @param  {String} prefix
 * @return {Object}
 */

export function getEntityItemData(state, type, id, fields) {
  var _context24, _context25, _context26;

  var prefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  type = camelCase(type);
  var item = get(state, _concatInstanceProperty(_context24 = _concatInstanceProperty(_context25 = _concatInstanceProperty(_context26 = "".concat(ENTITIES, ".")).call(_context26, type, ".")).call(_context25, ITEMS, ".")).call(_context24, id), {});

  if (!item[DATA]) {
    return null;
  }

  var responseItem = _objectSpread({}, item[DATA]);

  if (item.related) {
    var _loop = function _loop(fieldName) {
      var _context27;

      var fieldKey = prefix ? _concatInstanceProperty(_context27 = "".concat(prefix, ".")).call(_context27, fieldName) : fieldName;

      if (fields && isObject(fields) && !get(fields, fieldKey)) {
        return "continue";
      }

      var rel = item.related[fieldName];
      var isMulti = isArray(rel.type);
      var relType = isMulti ? rel.type[0] : rel.type;
      var items = rel[ITEMS];

      if (isMulti) {
        var _set;

        responseItem = set(responseItem, fieldName, (_set = {}, _defineProperty(_set, ITEMS, _mapInstanceProperty(items).call(items, function (relId) {
          return getEntityItemData(state, relType, relId, fields, fieldKey);
        })), _defineProperty(_set, PAGINATION, merge({}, defaultPaginationState, rel[PAGINATION] || {})), _set));
      } else {
        var relId = items[0];
        responseItem = set(responseItem, fieldName, getEntityItemData(state, relType, relId, fields, fieldKey));
      }
    };

    for (var fieldName in item.related) {
      var _ret2 = _loop(fieldName);

      if (_ret2 === "continue") continue;
    }
  }

  return responseItem;
}
export function getEntityItemEtagTree(state, type, id, fields) {
  var _context28, _context29, _context30, _context31;

  var prefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var etags = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  type = camelCase(type);
  var item = get(state, _concatInstanceProperty(_context28 = _concatInstanceProperty(_context29 = _concatInstanceProperty(_context30 = "".concat(ENTITIES, ".")).call(_context30, type, ".")).call(_context29, ITEMS, ".")).call(_context28, id), {}); // The same etag will always have the same sub tree, so skip existing etags all together

  if (!item[ETAG] || _includesInstanceProperty(etags).call(etags, item[ETAG])) {
    return etags;
  }

  etags = _concatInstanceProperty(_context31 = []).call(_context31, _toConsumableArray(etags), [item[ETAG]]);

  if (item.related) {
    var _loop2 = function _loop2(fieldName) {
      var _context32;

      var fieldKey = prefix ? _concatInstanceProperty(_context32 = "".concat(prefix, ".")).call(_context32, fieldName) : fieldName;

      if (fields && !get(fields, fieldKey)) {
        return "continue";
      }

      var rel = item.related[fieldName];
      var relType = isArray(rel.type) ? rel.type[0] : rel.type;
      var items = rel.items;

      _forEachInstanceProperty(items).call(items, function (relId) {
        etags = getEntityItemEtagTree(state, relType, relId, fields, fieldKey, etags);
      });
    };

    for (var fieldName in item.related) {
      var _ret3 = _loop2(fieldName);

      if (_ret3 === "continue") continue;
    }
  }

  return etags;
}
/**
 * Remove item / list data
 * @param  {Object} state
 * @param  {string} id
 * @return {Object}
 */

export function removeEntityItem(state, id) {
  var _context33;

  if (!get(state, _concatInstanceProperty(_context33 = "".concat(ITEMS, ".")).call(_context33, id))) {
    // Item doesn't exist, so don't do anything!
    if (__DEV__) {
      console.warn("Cannot remove item with ID \"".concat(id, "\""));
    }

    return state;
  }

  var newState = _objectSpread({}, state);

  delete newState[ITEMS][id]; // Also delete item from any list that might reference it!
  // That way we don't need to refresh lists after deleting items

  for (var listId in newState[LISTS]) {
    var _context34;

    var list = newState[LISTS][listId];

    if (list && _includesInstanceProperty(_context34 = list[ITEMS]).call(_context34, id)) {
      var _context35, _context36, _context37;

      newState = set(newState, _concatInstanceProperty(_context35 = _concatInstanceProperty(_context36 = "".concat(LISTS, ".")).call(_context36, listId, ".")).call(_context35, ITEMS), _filterInstanceProperty(_context37 = list[ITEMS]).call(_context37, function (i) {
        return i !== id;
      }));
    }
  }

  return newState;
}